import {
  viewport,
  colors,
  font,
  lineHeight,
} from "../../../styles/cssinjs/helpers/variables.js";

export default function SocialNavBox({ className }) {
  return (
    <figure className={`social-media-section ${className}`}>
      <a
        href="https://twitter.com/Setmore"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#a)">
            <path
              fill-rule="evenodd"
              clipRule="evenodd"
              d="M7.297 21c2.875 0 5.422-.734 7.64-2.203 2.032-1.313 3.61-3.078 4.735-5.297 1.094-2.094 1.64-4.266 1.64-6.516 0-.28-.015-.484-.046-.61a10.818 10.818 0 0 0 2.484-2.577c-.938.406-1.875.672-2.813.797C22 3.937 22.72 3.03 23.095 1.874c-.969.563-2.016.954-3.14 1.173a5.566 5.566 0 0 0-1.618-1.125 4.695 4.695 0 0 0-1.992-.422c-.875 0-1.688.219-2.438.656a4.817 4.817 0 0 0-1.781 1.805 4.88 4.88 0 0 0-.656 2.46c0 .376.031.75.094 1.126-2-.094-3.883-.594-5.649-1.5A13.572 13.572 0 0 1 1.438 2.39c-.47.78-.704 1.601-.704 2.46 0 .86.204 1.649.61 2.368a5.46 5.46 0 0 0 1.593 1.78 4.634 4.634 0 0 1-2.203-.655v.093c0 1.157.375 2.188 1.125 3.094.75.906 1.688 1.485 2.813 1.735-.438.093-.875.14-1.313.14-.28 0-.578-.015-.89-.047a4.895 4.895 0 0 0 1.71 2.414c.829.641 1.79.961 2.883.961-1.812 1.407-3.859 2.11-6.14 2.11-.438 0-.828-.016-1.172-.047C2.031 20.266 4.547 21 7.297 21z"
              fill="#1D90F5"
            ></path>
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M0 0h24v24H0z"></path>
            </clipPath>
          </defs>
        </svg>
      </a>
      <a
        href="https://www.youtube.com/Setmore"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#a)">
            <path
              fill-rule="evenodd"
              clipRule="evenodd"
              d="m12 20.098 4-.044c2.813-.087 4.6-.231 5.363-.434a3.055 3.055 0 0 0 1.362-.783c.381-.377.645-.812.791-1.304.206-.783.352-1.986.44-3.61L24 11.75l-.044-2.174c-.088-1.594-.234-2.783-.44-3.565a3.055 3.055 0 0 0-2.154-2.13c-.761-.203-2.549-.348-5.362-.435l-4-.044-4 .044c-2.813.087-4.6.232-5.363.434A3.055 3.055 0 0 0 .484 6.01c-.206.783-.352 1.972-.44 3.566C.014 10.388 0 11.112 0 11.75l.044 2.174c.088 1.623.234 2.826.44 3.609.146.492.41.927.79 1.304.382.377.836.638 1.363.783.762.203 2.55.347 5.363.434l4 .044zm-2.461-4.783V8.228l6.285 3.522-6.285 3.565z"
              fill="#1D90F5"
            ></path>
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M0 0h24v24H0z"></path>
            </clipPath>
          </defs>
        </svg>
      </a>
      <a
        href="https://www.facebook.com/SetmoreAppointments"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#a)">
            <path
              fill-rule="evenodd"
              clipRule="evenodd"
              d="M23.75 12.321C23.75 5.791 18.49.5 12 .5S.25 5.79.25 12.32c0 5.9 4.297 10.791 9.914 11.679v-8.261H7.18V12.32h2.985V9.717c0-2.963 1.753-4.6 4.438-4.6 1.286.001 2.63.232 2.63.232v2.907h-1.481c-1.46 0-1.915.912-1.915 1.846v2.22h3.259l-.521 3.417h-2.738v8.26c5.617-.887 9.914-5.777 9.914-11.678z"
              fill="#1D90F5"
            ></path>
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M0 0h24v24H0z"></path>
            </clipPath>
          </defs>
        </svg>
      </a>
      <a
        href="https://www.instagram.com/Setmore/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#a)">
            <path
              fill-rule="evenodd"
              clipRule="evenodd"
              d="M12.185 23.656c2.04-.003 3.526-.03 4.455-.078.996-.053 1.86-.201 2.594-.446a6.11 6.11 0 0 0 2.28-1.44 6.108 6.108 0 0 0 1.441-2.28c.245-.735.394-1.6.446-2.595.052-.996.079-2.63.079-4.9l-.001-.874a132.951 132.951 0 0 0-.052-4c-.07-1.014-.227-1.887-.472-2.62a6.108 6.108 0 0 0-1.44-2.28A6.11 6.11 0 0 0 19.234.7C18.5.456 17.634.308 16.64.255c-.996-.052-2.63-.078-4.9-.078h-.446C9.254.18 7.77.207 6.84.255c-.995.053-1.86.201-2.594.446a6.109 6.109 0 0 0-2.28 1.441 6.109 6.109 0 0 0-1.44 2.28C.28 5.156.13 6.021.078 7.016.026 8.012 0 9.646 0 11.916v.446c.004 2.04.03 3.526.079 4.455.052.996.2 1.86.445 2.594a6.11 6.11 0 0 0 1.441 2.28 5.587 5.587 0 0 0 2.28 1.389c.734.28 1.599.445 2.594.498.996.052 2.63.078 4.9.078h.446zm.813-2.096h-2.551a69.576 69.576 0 0 1-2.795-.052c-1.293-.07-2.236-.21-2.83-.42-1.049-.419-1.8-1.17-2.254-2.253-.21-.594-.35-1.538-.42-2.83a76.461 76.461 0 0 1-.052-3.25v-2.131c.004-1.18.022-2.112.053-2.795.07-1.328.21-2.271.419-2.83.42-1.084 1.17-1.835 2.254-2.254.594-.21 1.537-.35 2.83-.42a76.464 76.464 0 0 1 3.25-.052h1.676c1.398 0 2.48.018 3.25.053 1.327.07 2.27.21 2.83.419 1.083.42 1.834 1.17 2.253 2.254.21.559.35 1.502.42 2.83.035.733.052 1.817.052 3.25v1.676c0 1.398-.017 2.481-.052 3.25-.07 1.292-.21 2.236-.42 2.83-.419 1.048-1.17 1.8-2.253 2.253-.56.21-1.503.35-2.83.42a74.29 74.29 0 0 1-3.25.052h.42zm5.03-14.517c.385 0 .709-.14.97-.42.263-.28.411-.611.446-.995 0-.385-.14-.717-.42-.996a1.36 1.36 0 0 0-.995-.42c-.384 0-.716.14-.996.42-.28.28-.42.611-.42.996 0 .384.14.716.42.995.28.28.612.42.996.42zm-6.288 10.9c1.083 0 2.087-.27 3.013-.812a6.044 6.044 0 0 0 2.201-2.2c.542-.927.813-1.931.813-3.014 0-1.083-.27-2.088-.813-3.014a6.044 6.044 0 0 0-2.2-2.201 5.865 5.865 0 0 0-3.014-.812c-1.083 0-2.088.27-3.014.812a6.045 6.045 0 0 0-2.201 2.201 5.865 5.865 0 0 0-.812 3.014c0 1.083.27 2.087.812 3.013a6.044 6.044 0 0 0 2.201 2.201c.926.542 1.93.813 3.014.813zm0-2.096c-1.083 0-2.01-.384-2.778-1.153-.769-.768-1.153-1.694-1.153-2.777 0-1.083.384-2.01 1.153-2.778.769-.769 1.695-1.153 2.778-1.153s2.009.384 2.777 1.153c.77.769 1.154 1.695 1.154 2.778s-.385 2.009-1.153 2.777c-.77.769-1.695 1.153-2.778 1.153z"
              fill="#1D90F5"
            ></path>
          </g>
          <defs>
            <clipPath id="a">
              <path fill="#fff" d="M0 0h24v24H0z"></path>
            </clipPath>
          </defs>
        </svg>
      </a>
      <style jsx>{`
        figure {
          display: flex;
          gap: 14px;
          justify-content: center;
        }
        @media (max-width: ${viewport.tablet.sm}) {
          a {
            padding: 12px;
            // max-height: 48px;
          }
          figure {
            gap: 12px;
          }
          figure a svg {
            width: 24px;
            height: 24px;
          }
        }
      `}</style>
    </figure>
  );
}
